module.exports = __webpack_public_path__ + "img/title.8f011f5c.png";